import {
  CardDetails,
  CardDetailsProps,
} from "@/components/Dashboard/components/Card/Card.Details";

export type CardMainProps = CardDetailsProps;

export const CardMain = ({ ...props }: CardMainProps) => {
  return (
    <div>
      <CardDetails {...props} />
    </div>
  );
};
